// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"trustpilot_wrapper__azS_t","on-hero":"trustpilot_on-hero__xdeaF"};